// extracted by mini-css-extract-plugin
export var active = "_70-a";
export var activeIndicator = "_70-9";
export var disabled = "_70-b";
export var fullWidth = "_70-2";
export var lg = "_70-7";
export var md = "_70-6";
export var redoButtonTabGroup = "_70-0";
export var sm = "_70-5";
export var tabButton = "_70-4";
export var tabButtonsContainer = "_70-1";
export var themeDestructive = "_70-d";
export var themeNormal = "_70-c";
export var themeSuccess = "_70-e";
export var xl = "_70-8";
export var xs = "_70-3";